<div class="send-money">
    <div class="row m-0">
        <div class="col-md-6 head-top">
            <h5 class="sm-18 color-blue mb-4 font-weight-bold ">Who are you sending money to?</h5>
            <div (click)="selectContact(contact)" *ngFor="let contact of sendMoneyService.contacts" [ngClass]="{'bg-primary': contact==sendMoneyService.receiver}" class="card  border-0 my-2" style="border-radius: 5px;">
                <div class="card-body" *ngIf="auth.user.country_id==233">
                    <div class="row">  
                        <div class="col-8">
                            <h5 class=" sm-16 color-royalblue"> 
                                {{contact.first_name}} {{contact.last_name}}  
                                <span [innerHTML]="mobileIcon(contact.transaction_type)"></span>
                            </h5>
                        </div>
                        <div class="col-4">
                            <button class="btn select-btn sm-10 h-auto primary-text">
                                {{contact==selectedContact?'Selected':'Select'}}
                            </button>
                            <!-- <img *ngIf="contact==selectedContact" src="assets/images/check.png"> -->
                        </div>
                    </div>
                    <div class="custom-text-font color-lightgray sm-10" *ngIf="contact.account_number" style="text-transform: capitalize;">
                        {{contact.bank_name}} 
                        account ending in 
                        {{contact.account_number.substr(contact.account_number.length - 4)}}
                    </div>
                    <div class="custom-text-font color-lightgray sm-10" *ngIf="+contact.deposit_number">
                        Deposit number ending in 
                        {{+contact.deposit_number.substr(+contact.deposit_number.length - 4)}}
                    </div>
                    
                </div>
                <div class="card-body" *ngIf="auth.user.country_id==39">
                    <div class="row">  
                        <div class="col-8" >
                            <h5 class=" sm-16 color-royalblue" style="text-transform: capitalize;"> 
                                {{contact.payee_name}}  
                                <span [innerHTML]="mobileIcon(contact.transaction_type)"></span>
                            </h5>
                        </div>
                        <div class="col-4">
                            <button class="btn select-btn sm-10 h-auto primary-text">{{contact==selectedContact?'Selected':'Select'}}</button>
                            <!-- <img alt="Send Money" *ngIf="contact==selectedContact" src="assets/images/check.png"> -->
                        </div>
                    </div>
                    <div class="custom-text-font color-lightgray sm-10" *ngIf="contact.payee_bank_name">
                        {{contact.payee_bank_name}} 
                        account ending in 
                        {{+contact.payee_account_number.substr(+contact.payee_account_number.length - 4) || +contact.iban.substr(+contact.iban.length - 4)}}
                    </div>
                    <div class="custom-text-font color-lightgray sm-10" *ngIf="contact.mobile_provider_name">
                        {{contact.mobile_provider_name}} 
                        deposit number ending in 
                        {{+contact.deposit_number.substr(+contact.deposit_number.length - 4)}}
                    </div>
                </div>
            </div>
            <div class="w-100 d-flex align-items-center justify-content-center justify-content-md-end my-2" *ngIf="!(sendMoneyService.last_page == 1)">
                <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="sendMoneyService.setContacts(+sendMoneyService.current_page-1)" [disabled]='sendMoneyService.prev_disabled'> 
                    <i class="fas fa-arrow-left mr-1"></i> Previous
                </button>
                <span class="col-2 text-center sm-10 gilroy-bold color-blue">{{ sendMoneyService.current_page }}/{{ sendMoneyService.last_page }}</span>
                <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="sendMoneyService.setContacts(+sendMoneyService.current_page+1)" [disabled]='sendMoneyService.next_disabled'>
                    Next <i class="fas fa-arrow-right ml-1"></i>
                </button>
            </div>
            <div class="card  border-0 mt-3" style="border-radius: 5px;">
                <div class="card-body">
                    <app-create-contact (ContactCreated)="onNewContactCreated($event)"></app-create-contact>
                </div>
            </div>
            <div class="div d-flex  my-3 address_field">
                <!-- <button  type="button" class="btn transparent-btn primary-text back-btn">Cancel</button> -->
                <button (click)="goAhead()" [disabled]="!sendMoneyService.receiver" class="btn btn-primary  w-100">Next</button>
            </div>
        </div>
    </div>